import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "./images/GDDC LOGO.png";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [theme, setTheme] = useState("light");
  const [openDropdown, setOpenDropdown] = useState(null);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    {
      to: "/services",
      label: "Services",
      dropdown: true,
      subLinks: [
        {
          to: "/services/research-and-publications",
          label: "Research and Publications",
        },
        { to: "/services/training-and-workshops", label: "Trainings/Workshop" },
        { to: "/services/certification", label: "Certification" },
        { to: "/services/policy-development", label: "Policy Development" },
        { to: "/services/consultancy", label: "Consultancy" },
      ],
    },
    { to: "/events", label: "Events" },
    { to: "/contact", label: "Contact" },
    {
      label: "More",
      dropdown: true,
      subLinks: [
        { to: "/news", label: "News" },
        { to: "/membership", label: "Membership" },
        { to: "/awards", label: "Awards" },
        { to: "/resources", label: "Resources" },
      ],
    },
  ];
  

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
    }

    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const closeAllDropdowns = () => {
    setOpenDropdown(null);
    setIsMenuOpen(false);
  };

  return (
    <div
      className={`container-fluid border-bottom ${
        theme === "dark" ? "bg-dark" : "bg-light"
      } ${isSticky ? "fixed-top shadow-sm" : ""}`}
    >
      {!isSticky && (
        <div
          className={`container topbar d-none d-lg-block py-2 ${
            theme === "dark" ? "bg-secondary" : "bg-success"
          }`}
          style={{ borderRadius: "0 40px" }}
        >
          <div className="d-flex justify-content-between">
            <div className="top-info ps-2">
              <small className="me-3">
                <i className="fas fa-map-marker-alt me-2 text-danger"></i>
                <span
                  className={theme === "dark" ? "text-light" : "text-white"}
                >
                  P.O Box 2221-00200, Nairobi
                </span>
              </small>
            </div>
            <div className="top-link pe-2">
              <small className="me-3">
                <i className="fas fa-envelope me-2 text-danger"></i>
                <span
                  className={theme === "dark" ? "text-light" : "text-white"}
                >
                  info@gddckenya.org
                </span>
              </small>
              <small>
                <i className="fas fa-phone me-2 text-danger"></i>
                <span
                  className={theme === "dark" ? "text-light" : "text-white"}
                >
                  0726346929 / 0722451844
                </span>
              </small>
            </div>
          </div>
        </div>
      )}

      <div className="container px-0">
        <nav
          className={`navbar navbar-expand-xl py-3 ${
            theme === "dark" ? "navbar-dark" : "navbar-light"
          }`}
        >
          <NavLink to="/" className="navbar-brand" onClick={closeAllDropdowns}>
            <img
              src={logo}
              alt="GDDC Kenya logo"
              className="img-fluid rounded"
              style={{ maxWidth: "90px", height: "auto" }}
            />
          </NavLink>

          {/* Mobile controls - grouped together */}
          <div className="d-flex align-items-center d-xl-none">
            <button
              className="btn btn-outline-secondary me-2"
              onClick={toggleTheme}
              aria-label={`Switch to ${
                theme === "light" ? "dark" : "light"
              } mode`}
              title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
              style={{ border: "none" }}
            >
              <i
                className={`fas ${theme === "light" ? "fa-moon" : "fa-sun"}`}
                aria-hidden="true"
              ></i>
            </button>

            <button
              className="navbar-toggler py-2 px-3"
              type="button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ border: "none", outline: "none", boxShadow: "none" }}
              aria-expanded={isMenuOpen}
              aria-label={
                isMenuOpen ? "Close navigation menu" : "Open navigation menu"
              }
            >
              <span
                className={`fa ${isMenuOpen ? "fa-times" : "fa-bars"} ${
                  theme === "dark" ? "text-light" : "text-secondary"
                }`}
              ></span>
            </button>
          </div>

          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
            id="navbarCollapse"
          >
            <div className="navbar-nav d-flex justify-content-start justify-content-xl-end ms-xl-auto">
              {navLinks.map((link, index) =>
                link.dropdown ? (
                  <div
                    className="nav-item dropdown"
                    key={index}
                    onMouseEnter={() => !isMenuOpen && setOpenDropdown(index)}
                    onMouseLeave={() => !isMenuOpen && setOpenDropdown(null)}
                  >
                    <button
                      className="nav-link dropdown-toggle fw-bold text-uppercase d-flex align-items-center"
                      onClick={() => toggleDropdown(index)}
                      style={{
                        fontSize: "1rem",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                      aria-expanded={openDropdown === index}
                      aria-haspopup="true"
                      aria-controls={`dropdown-menu-${index}`}
                      aria-label={`Toggle ${link.label} menu`}
                    >
                      {link.label}
                      <i
                        className="fas fa-angle-down ms-2"
                        aria-hidden="true"
                      ></i>
                    </button>

                    <ul
                      className={`dropdown-menu ${
                        theme === "dark" ? "bg-dark" : ""
                      } ${openDropdown === index ? "show" : ""}`}
                    >
                      {link.subLinks.map((subLink, subIndex) => (
                        <li key={subIndex}>
                          <NavLink
                            to={subLink.to}
                            className={`dropdown-item text-capitalize ${
                              theme === "dark" ? "text-light" : ""
                            }`}
                            onClick={closeAllDropdowns}
                          >
                            {subLink.label}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <NavLink
                    key={index}
                    to={link.to}
                    className={({ isActive }) =>
                      `nav-item nav-link me-3 fw-bold text-uppercase ${
                        isActive ? "active" : ""
                      }`
                    }
                    style={{ fontSize: "1rem" }}
                    onClick={closeAllDropdowns}
                    end
                  >
                    {link.label}
                  </NavLink>
                )
              )}
            </div>

            {/* Theme Toggle Button - Desktop */}
            <button
              className="btn btn-outline-secondary ms-3 d-none d-xl-block"
              onClick={toggleTheme}
              aria-label={`Switch to ${
                theme === "light" ? "dark" : "light"
              } mode`}
              title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
              style={{ border: "none" }}
            >
              <i
                className={`fas ${theme === "light" ? "fa-moon" : "fa-sun"}`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </nav>
      </div>
    </div>
  );
}
